import React from 'react';
import CompanyDashboardPage from '../CompanyDashboardPage/CompanyDashboardPage';

/**
 * Dashboard para administradores de sucursal.
 *
 * Mantiene la presentación del dashboard de empresa, pero fija el alcance a la
 * sucursal seleccionada en el Header. La ruta de superadministración conserva
 * su selector interno y su navegación independiente.
 */
export default function AdminCompanyDashboardPage() {
  return <CompanyDashboardPage activeBranchScope showSidebar={false} />;
}
